var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar',{attrs:{"bar-title":"添加基金"}}),_c('div',{staticClass:"form",staticStyle:{"padding":"55px 4% 56px 4%"}},[_c('fund-form',{ref:"form",attrs:{"settings":_vm.settings},on:{"subData":_vm.subData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }